import coreModule from 'app/core/core_module';

export class ExperimentsSearchSrv {
  constructor(private backendSrv) {}

  search(query) {
    return this.backendSrv.get('/api/experiments/search', query).then(response => {
      return this.handleSearchResults(response);
    });
  }

  handleSearchResults(response) {
    console.log('handleSearchResults()', response);
    response.results.map(experiment => {
      experiment.created = new Date(experiment.created);

      if (experiment.tZero === '0001-01-01T00:00:00Z') {
        experiment.tZero = null;
      } else {
        experiment.tZero = new Date(experiment.tZero);
      }

      if (experiment.type === 'folder') {
        experiment.icon = 'fa fa-folder';
        experiment.items = [];
        experiment.toggle = this.toggleFolder.bind(this);
      } else {
        experiment.icon = 'fa fa-flask';
      }
    });

    return response;
  }

  private toggleFolder(section) {
    section.expanded = !section.expanded;
    section.icon = section.expanded ? 'fa fa-folder-open' : 'fa fa-folder';

    if (section.items.length) {
      return Promise.resolve(section);
    }

    let query = {
      folderIds: [section.id],
    };

    return this.backendSrv.get('/api/experiments/search', query).then(response => {
      response = this.handleSearchResults(response);
      section.items = response.results;
      return Promise.resolve(section);
    });
  }
}

coreModule.service('experimentsSearchSrv', ExperimentsSearchSrv);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/experiments_search_srv.ts